import { ComponentList } from '@common/gems/types';

export interface ComponentListState {
  data: ComponentList;
}

export enum GemSectionCategory {
  Spark = 'Spark',
  Airflow = 'Airflow'
}

export type GemToolbarProps = {
  section: GemSectionCategory;
  gemCategories: { [key: string]: boolean };
  onAddGem: () => void;
};
